import React from "react";
import { TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import theme from "../../styles/styleTheme";

interface PropertyRangeProps {
  minValue: number;
  maxNumber: number;
  step: number;
  value: number[];
  setValue: any;
  labelMin: string;
  labelMax: string;
}

const PropertyRange = ({
  maxNumber,
  minValue,
  step,
  value,
  labelMin,
  labelMax,
  setValue,
}: PropertyRangeProps) => {
  const handleSliderChange = (_: Event, newValue: number | number[]) => {
    setValue(newValue as number[]);
  };

  const handleMinInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = [Number(event.target.value), value[1]];
    setValue(newValue);
  };

  const handleMaxInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = [value[0], Number(event.target.value)];
    setValue(newValue);
  };

  const dynamicMaxValue = Math.max(maxNumber, value[1]);

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={2}
      width={"100%"}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexDirection={"column"}
        width={"100%"}
      >
        <Slider
          value={value}
          onChange={handleSliderChange}
          valueLabelDisplay="auto"
          marks
          min={minValue}
          max={dynamicMaxValue}
          step={step}
          sx={{
            color: theme.palette.primary.main,
          }}
        />

        <Box
          marginTop={1}
          marginBottom={1}
          gap={2}
          alignItems={"center"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <TextField
            // type="number"
            label={labelMin}
            variant="outlined"
            size="small"
            value={value[0]}
            sx={{
              left: "-.5rem"
            }}
            onChange={handleMinInputChange}
          />
          <Typography>t/m</Typography>
          <TextField
            // type="number"
            label={labelMax}
            variant="outlined"
            size="small"
            sx={{
              left: ".25rem"
            }}
            value={value[1]}
            onChange={handleMaxInputChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PropertyRange;
